var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            "label-position": "right",
            inline: "",
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.listNumber") } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "", type: "text" },
                    model: {
                      value: _vm.childData.flowNum,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "flowNum", $$v)
                      },
                      expression: "childData.flowNum"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.house") } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "", type: "text" },
                    model: {
                      value: _vm.childData.theHouseCode,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "theHouseCode", $$v)
                      },
                      expression: "childData.theHouseCode"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.repairPerson") } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "", type: "text" },
                    model: {
                      value: _vm.childData.userName,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "userName", $$v)
                      },
                      expression: "childData.userName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.contactNumber") } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "", type: "text" },
                    model: {
                      value: _vm.childData.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "phone", $$v)
                      },
                      expression: "childData.phone"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.repairDetail") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "720px" },
                    attrs: {
                      disabled: "",
                      type: "textarea",
                      autosize: { minRows: 3, maxRows: 3 }
                    },
                    model: {
                      value: _vm.childData.content,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "content", $$v)
                      },
                      expression: "childData.content"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.remark") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "720px" },
                    attrs: {
                      placeholder: "请输入备注",
                      type: "textarea",
                      maxlength: "255",
                      autosize: { minRows: 3, maxRows: 3 }
                    },
                    model: {
                      value: _vm.submitList.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.submitList, "remark", $$v)
                      },
                      expression: "submitList.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handPass } },
            [_vm._v(_vm._s(_vm.$t("button.auditPass")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handUnPass } },
            [_vm._v(_vm._s(_vm.$t("button.auditUnPass")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }